import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import axios from '../../axios.js';
import moment from 'moment/moment';


import '../Resources/dashboard.css';
import Navbar from './navbar';
import Sidebar from './sidebar.js';


import Chart from "chart.js/auto";
import { Line, Bar, Pie } from "react-chartjs-2";

import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';

//EXCEL DOWNLOAD IMPORT
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Newcrm_createlead from './newcrm_createlead.js';

function Newcrm_leads(){



  
 //Report Print Function
 const componentRef = useref();
 const handlePrint = useReactToPrint({
   content: () => componentRef.current,
 });

 
  // Function to download the data as an Excel file
  /*const downloadExcel = () => {
    // Convert JSON data to Excel worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);
    
    // Create a new workbook and add the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    
    // Convert the workbook to a binary array
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    
    // Create a Blob from the binary data and trigger a download
    const excel_data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(excel_data, "sales_data.xlsx");
  };
  */
  
  
  
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const busyid=sessionStorage.getItem("BusyId00");
 const counterid=sessionStorage.getItem("CounterId00");


 

 {/* SALES TRANSACTIONS TABLE COLUMNS MANAGEMENT VARIABLES START */}
const[cd_col1_val,setcd_col1_val] = useState(0);//column1
const[cd_col2_val,setcd_col2_val] = useState(0);//column2
const[cd_col3_val,setcd_col3_val] = useState(0);//column3
const[cd_col4_val,setcd_col4_val] = useState(0);//column4
const[cd_col5_val,setcd_col5_val] = useState(0);//column5
const[cd_col6_val,setcd_col6_val] = useState(0);//column6
const[cd_col7_val,setcd_col7_val] = useState(0);//column7
const[cd_col8_val,setcd_col8_val] = useState(0);//column8
const[cd_col9_val,setcd_col9_val] = useState(0);//column9
const[cd_col10_val,setcd_col10_val] = useState(0);//column10
const[cd_col11_val,setcd_col11_val] = useState(0);//column11
const[cd_col12_val,setcd_col12_val] = useState(0);//column12
const[cd_col13_val,setcd_col13_val] = useState(0);//column13
const[cd_col14_val,setcd_col14_val] = useState(0);//column14
{/* SALES TRANSACTIONS TABLE COLUMNS MANAGEMENT VARIABLES END */}

 //Checking if Sessions are Set

// alert(logstatus,loguser,logadminid);
 //Sessions Not Set
/* if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))||((busyid==null)||(busyid==" "))||((counterid==null)||(counterid==" "))){
  
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   
 
    window.location.replace("/businesstools-login");
   }
  
   //Sessions Set
   else{
*/

    
    
      
//Variables
const[ecustomers,setecustomers] = useState([],);//SetData Variable
const[ecdefault,setecdefault] = useState(0);
const[banks,setbanks] = useState([]);//SetData Variable
const[data,setData] = useState([]);//SetData Variable

//Error Variable
const[errorvar,seterrorvar] = useState();



//FILTER VARIABLES
const[filter_val,setfilter_val] = useState(0);


const[filter_customer_id,setfilter_customer_id] = useState(); const updatefilter_customer_id = (event) => { setfilter_customer_id(event.target.value);}; const[filter_customer_id_er,setfilter_customer_id_er]=useState();
const[filter_customer_name,setfilter_customer_name] = useState(); const updatefilter_customer_name = (event) => { setfilter_customer_name(event.target.value);}; const[filter_customer_name_er,setfilter_customer_name_er]=useState();
const[filter_email,setfilter_email] = useState(); const updatefilter_email = (event) => { setfilter_email(event.target.value);}; const[filter_email_er,setfilter_email_er]=useState();
const[filter_contact,setfilter_contact] = useState(); const updatefilter_contact = (event) => { setfilter_contact(event.target.value);}; const[filter_contact_er,setfilter_contact_er]=useState();
const[filter_followup_date,setfilter_followup_date] = useState(); const updatefilter_followup_date = (event) => { setfilter_followup_date(event.target.value);}; const[filter_followup_date_er,setfilter_followup_date_er]=useState();
const[filter_consulting_for,setfilter_consulting_for] = useState(); const updatefilter_consulting_for = (event) => { setfilter_consulting_for(event.target.value);}; const[filter_consulting_for_er,setfilter_consulting_for_er]=useState();
const[filter_action,setfilter_action] = useState(); const updatefilter_action = (event) => { setfilter_action(event.target.value);}; const[filter_action_er,setfilter_action_er]=useState();
const[filter_followup_mode,setfilter_followup_mode] = useState(); const updatefilter_followup_mode = (event) => { setfilter_followup_mode(event.target.value);}; const[filter_followup_mode_er,setfilter_followup_mode_er]=useState();
const[filter_lead_stage,setfilter_lead_stage] = useState(); const updatefilter_lead_stage = (event) => { setfilter_lead_stage(event.target.value);}; const[filter_lead_stage_er,setfilter_lead_stage_er]=useState();
const[filter_service_status,setfilter_service_status] = useState(); const updatefilter_service_status = (event) => { setfilter_service_status(event.target.value);}; const[filter_service_status_er,setfilter_service_status_er]=useState();
const[filter_customer_status,setfilter_customer_status] = useState(); const updatefilter_customer_status = (event) => { setfilter_customer_status(event.target.value);}; const[filter_customer_status_er,setfilter_customer_status_er]=useState();
const[filter_next_followup_date,setfilter_next_followup_date] = useState(); const updatefilter_next_followup_date = (event) => { setfilter_next_followup_date(event.target.value);}; const[filter_next_followup_date_er,setfilter_next_followup_date_er]=useState();
const[filter_start_followup_date,setfilter_start_followup_date] = useState('1970-01-01'); const updatefilter_start_followup_date = (event) => { setfilter_start_followup_date(event.target.value);}; const[filter_start_followup_date_er,setfilter_start_followup_date_er]=useState();
const[filter_end_followup_date,setfilter_end_followup_date] = useState('2100-12-12'); const updatefilter_end_followup_date = (event) => { setfilter_end_followup_date(event.target.value);}; const[filter_end_followup_date_er,setfilter_end_followup_date_er]=useState();
const[filter_start_next_followup_date,setfilter_start_next_followup_date] = useState('1970-01-01'); const updatefilter_start_next_followup_date = (event) => { setfilter_start_next_followup_date(event.target.value);}; const[filter_start_next_followup_date_er,setfilter_start_next_followup_date_er]=useState();
const[filter_end_next_followup_date,setfilter_end_next_followup_date] = useState('2100-12-12'); const updatefilter_end_next_followup_date = (event) => { setfilter_end_next_followup_date(event.target.value);}; const[filter_end_next_followup_date_er,setfilter_end_next_followup_date_er]=useState();


//Variables for pagination
const [currentPage, setCurrentPage] = useState(1);
const [pageNumber, setpageNumber] = useState(1);

useEffect(()=>{
   
  getData();
  
  },[])
 

  
  
 //SETTING DEFAULT STATE VARIABLES FOR CHART */
 
//******************* GET SALES DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
    
  //Fetching Filter Variables
  const $filter_customer_id = filter_customer_id;const $filter_customer_name = filter_customer_name;const $filter_email = filter_email;const $filter_contact = filter_contact;
  const $filter_followup_date = filter_followup_date;const $filter_consulting_for = filter_consulting_for;const $filter_action = filter_action;const $filter_followup_mode = filter_followup_mode;const $filter_lead_stage = filter_lead_stage;
  const $filter_service_status = filter_service_status;const $filter_customer_status = filter_customer_status;const $filter_next_followup_date = filter_next_followup_date;
  const $filter_start_followup_date = filter_start_followup_date;  const $filter_end_followup_date = filter_end_followup_date;
  const $filter_start_next_followup_date = filter_start_next_followup_date;  const $filter_end_next_followup_date = filter_end_next_followup_date;
 
 axios.post("newcrm-get-leads_history", {
   Log_id:logid,
   Token:token,
   Busy_id:busyid,
   Counter_id:counterid,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,
    //Filters
  Filter_val : filter_val,
  Filter_customer_id : $filter_customer_id,
  Filter_customer_name : $filter_customer_name,
  Filter_email : $filter_email,
  Filter_contact : $filter_contact,
  Filter_followup_date : moment($filter_followup_date).format('YYYY-MM-DD'),
  Filter_consulting_for : $filter_consulting_for,
  Filter_action : $filter_action,
  Filter_followup_mode : $filter_followup_mode,
  Filter_lead_stage : $filter_lead_stage,
  Filter_service_status : $filter_service_status,
  Filter_customer_status : $filter_customer_status,
  Filter_next_followup_date : moment($filter_next_followup_date).format('YYYY-MM-DD'),
  Filter_start_followup_date : moment($filter_start_followup_date).format('YYYY-MM-DD'),
  Filter_end_followup_date : moment($filter_end_followup_date).format('YYYY-MM-DD'),
  Filter_start_next_followup_date : moment($filter_start_next_followup_date).format('YYYY-MM-DD'),
  Filter_end_next_followup_date : moment($filter_end_next_followup_date).format('YYYY-MM-DD'),
   //Code Edits for pagination
   'page' : pageNumber

 })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("CounterId00");

     window.location.replace("businesstools-login");
  }
  //Success Data Fetched
  if(response.data.successvar==1){
 
   setData(response.data.data.data);
 
  }
  //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){
    setfilter_customer_id_er(response.data.validatorerror.Filter_customer_id);
    setfilter_customer_name_er(response.data.validatorerror.Filter_customer_name);
    setfilter_email_er(response.data.validatorerror.Filter_email);
    setfilter_contact_er(response.data.validatorerror.Filter_contact);
    setfilter_followup_date_er(response.data.validatorerror.Filter_followup_date);
    setfilter_consulting_for_er(response.data.validatorerror.Filter_consulting_for);
    setfilter_action_er(response.data.validatorerror.Filter_action);
    setfilter_followup_mode_er(response.data.validatorerror.Filter_followup_mode);
    setfilter_lead_stage_er(response.data.validatorerror.Filter_lead_stage);
    setfilter_service_status_er(response.data.validatorerror.Filter_service_status);
    setfilter_customer_status_er(response.data.validatorerror.Filter_customer_status);
    setfilter_next_followup_date_er(response.data.validatorerror.Filter_next_followup_date);
    setfilter_start_followup_date_er(response.data.validatorerror.Filter_start_followup_date);
    setfilter_end_followup_date_er(response.data.validatorerror.Filter_end_followup_date);
    setfilter_start_next_followup_date_er(response.data.validatorerror.Filter_start_next_followup_date);
    setfilter_end_next_followup_date_er(response.data.validatorerror.Filter_end_next_followup_date);

  }

  //Data Violation
  if(response.data.error==102){ 
  
    setfilter_customer_id_er(response.data.filter_customer_id_er);
    setfilter_customer_name_er(response.data.filter_customer_name_er);
    setfilter_email_er(response.data.filter_email_er);
    setfilter_contact_er(response.data.filter_contact_er);
    setfilter_followup_date_er(response.data.filter_followup_date_er);
    setfilter_consulting_for_er(response.data.filter_consulting_for_er);
    setfilter_action_er(response.data.filter_action_er);
    setfilter_followup_mode_er(response.data.filter_followup_mode_er);
    setfilter_lead_stage_er(response.data.filter_lead_stage_er);
    setfilter_service_status_er(response.data.filter_service_status_er);
    setfilter_customer_status_er(response.data.filter_customer_status_er);
    setfilter_next_followup_date_er(response.data.filter_next_followup_date_er);
    setfilter_start_followup_date_er(response.data.filter_start_followup_date_er);
    setfilter_end_followup_date_er(response.data.filter_end_followup_date_er);
    setfilter_start_next_followup_date_er(response.data.filter_start_next_followup_date_er);
    setfilter_end_next_followup_date_er(response.data.filter_end_next_followup_date_er);

  }
  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");


   window.location.replace("/");
 
  }

 }
  
 //******************* GET SALES DATA FUNCTION END  ********************//



 

//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();




//******************* GET EXCEL DATA FUNCTION START  ********************//
function getexcelData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
    
  //Fetching Filter Variables
  const $filter_customer_id = filter_customer_id;const $filter_customer_name = filter_customer_name;const $filter_email = filter_email;const $filter_contact = filter_contact;
  const $filter_followup_date = filter_followup_date;const $filter_consulting_for = filter_consulting_for;const $filter_action = filter_action;const $filter_followup_mode = filter_followup_mode;const $filter_lead_stage = filter_lead_stage;
  const $filter_service_status = filter_service_status;const $filter_customer_status = filter_customer_status;const $filter_next_followup_date = filter_next_followup_date;
  const $filter_start_followup_date = filter_start_followup_date;  const $filter_end_followup_date = filter_end_followup_date;
  const $filter_start_next_followup_date = filter_start_next_followup_date;  const $filter_end_next_followup_date = filter_end_next_followup_date;
 
 axios.post("newcrm-get-leads_history-inexcel", {
   Log_id:logid,
   Token:token,
   Busy_id:busyid,
   Counter_id:counterid,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,
    //Filters
  Filter_val : filter_val,
  Filter_customer_id : $filter_customer_id,
  Filter_customer_name : $filter_customer_name,
  Filter_email : $filter_email,
  Filter_contact : $filter_contact,
  Filter_followup_date : moment($filter_followup_date).format('YYYY-MM-DD'),
  Filter_consulting_for : $filter_consulting_for,
  Filter_action : $filter_action,
  Filter_followup_mode : $filter_followup_mode,
  Filter_lead_stage : $filter_lead_stage,
  Filter_service_status : $filter_service_status,
  Filter_customer_status : $filter_customer_status,
  Filter_next_followup_date : moment($filter_next_followup_date).format('YYYY-MM-DD'),
  Filter_start_followup_date : moment($filter_start_followup_date).format('YYYY-MM-DD'),
  Filter_end_followup_date : moment($filter_end_followup_date).format('YYYY-MM-DD'),
  Filter_start_next_followup_date : moment($filter_start_next_followup_date).format('YYYY-MM-DD'),
  Filter_end_next_followup_date : moment($filter_end_next_followup_date).format('YYYY-MM-DD'),
   //Code Edits for pagination
   'page' : pageNumber

 })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("CounterId00");

     window.location.replace("businesstools-login");
  }
  //Success Data Fetched
    if(response.data.successvar==1){
      //Setting Data
    const exceldata =response.data.data;
     
    // Convert JSON data to Excel worksheet
    const worksheet = XLSX.utils.json_to_sheet(exceldata);
    
    // Create a new workbook and add the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    
    // Convert the workbook to a binary array
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    
    // Create a Blob from the binary data and trigger a download
    const excel_data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(excel_data, "data.xlsx");
   }
   //Cannot Fetch Data
   else{
     seterrorvar("Cannot Download Excel File !");
   }
  
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");


   window.location.replace("/");
 
  }

 }
  
 //******************* GET EXCEL DATA FUNCTION END  ********************//





return(
    <>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>BUSINESS SAMADHAN - CRM</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div class="container-scroller">

      <Sidebar />
    <div class="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div class="main-panel">

             {/* SUCCESS CARD START */}
             <div class="d-flex justify-content-center">
          <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">New Transaction Added Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to close.</p>
                      <a href="businesstools-user-sales-addproducts"><button class="mt-3 btn btn-outline-danger">Close</button></a>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/* SUCCESS CARD END */}


           

          <div class="content-wrapper pb-0">

        {/*}  <div class="row">
              <div class="col-12 grid-margin create-form" id="create-form">
               <Newcrm_createlead />
              </div>
          </div> */}

            <div class="page-header flex-wrap">
            <div class="header-left"></div>
              <div class="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pe-3">Leads History</p>
                  </a>
                  <a class="ps-3 me-4" href="#">
                  {/*}  <p class="m-0">ADE-00234</p> */}
                  </a>
                </div>
              {/*}  <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text" onClick={()=>{ 
               const createForm = document.getElementById('create-form');
               const currentDisplay = createForm.style.display;
               createForm.style.display = currentDisplay === 'none' ? 'block' : 'none'; }}>
                  <i class="mdi mdi-plus-circle"></i> New Lead </button> */}
              </div>
            </div>

         
             

                  {/* SALES TRANSACTIONS LIST START */}
             <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Customer Leads History</h4>
                    <p class="card-description">all customer leads history
                    </p>

                      {/* FILTER SECTION START */}
                           <hr/>
                            <div id="filter-top-card" class="row col-12" style={{textAlign:"left",display:"none"}}>
                            <div class="d-flex justify-content-between">
                            <div>
                            <h4 style={{padding:'1rem'}}>Filters</h4>
                           </div>
                           <div>
                    
                           <button type="button" class="btn btn-social-icon" onClick={()=>{ document.getElementById("filter-top-card").style.display="none"; }}>
                           <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                           </button>
                           </div>
                           </div>
        
                        <div class="row">
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Customer Id</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" placeholder="CID0001" id="filter_customer_id" value={filter_customer_id} onChange={updatefilter_customer_id}  />
                              <code>{filter_customer_id_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Customer Name</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" placeholder="Sohan Kumar" id="filter_customer_name" value={filter_customer_name} onChange={updatefilter_customer_name}  />
                              <code>{filter_customer_name_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Email</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" placeholder="suman12345@gmail.com"   id="filter_email" value={filter_email} onChange={updatefilter_email}  />
                              <code>{filter_email_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Contact</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" placeholder="12345"   id="filter_contact" value={filter_contact} onChange={updatefilter_contact}  />
                              <code>{filter_contact_er}</code>
                            </div>
                          </div>
                        </div>
                {/*}      <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Followup Date</label>
                            <div class="col-sm-8">
                              <input type="date" class="form-control" placeholder="12345"   id="filter_followup_date" value={filter_followup_date} onChange={updatefilter_followup_date}  />
                              <code>{filter_followup_date_er}</code>
                            </div>
                          </div>
                        </div> */}
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Consulting For</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" placeholder="enter service name"   id="filter_consulting_for" value={filter_consulting_for} onChange={updatefilter_consulting_for}  />
                              <code>{filter_consulting_for_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Action</label>
                            <div class="col-sm-8">
                              <select class="form-control" placeholder="12345"   id="filter_action" style={{padding:"1rem"}} value={filter_action} onChange={updatefilter_action} >
                              <option value=" ">all</option>
                              <option value="primary enquiry">primary enquiry</option>
                              <option value="message received">message received</option>
                              <option value="message sent">message sent</option>
                              <option value="payment request">payment request</option>
                              <option value="consultancy">consultancy</option>
                              <option value="payment done">payment done</option>
                              <option value="service assigned">service assigned</option>
                              <option value="service completion">service completion</option>
                              </select>
                              <code>{filter_action_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Followup Mode</label>
                            <div class="col-sm-8">
                              <select class="form-control" placeholder="12345"   id="filter_followup_mode" style={{padding:"1rem"}} value={filter_followup_mode} onChange={updatefilter_followup_mode}  >
                              <option value=" ">all</option>
                              <option value="whatsapp">whatsapp</option>
                              <option value="phone call">phone call</option>
                              <option value="message">message</option>
                              <option value="online meeting">online meeting</option>
                              <option value="offline meeting">offline meeting</option>
                              <option value="other">other</option>
                              </select>
                              <code>{filter_followup_mode_er}</code>
                            </div>
                          </div>
                        </div>
                      {/*}  <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Next Followup Date</label>
                            <div class="col-sm-8">
                              <input type="date" class="form-control" placeholder="12345"   id="filter_next_followup_date" value={filter_next_followup_date} onChange={updatefilter_next_followup_date}  />
                              <code>{filter_next_followup_date_er}</code>
                            </div>
                          </div>
                        </div>*/}

                      </div>
                      
                      <div class="row">
                      <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Followup Start Date</label>
                            <div class="col-sm-8">
                              <input type="date" class="form-control" placeholder="12345"   id="filter_start_followup_date" value={filter_start_followup_date} onChange={updatefilter_start_followup_date}  />
                              <code>{filter_start_followup_date_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Followup End Date</label>
                            <div class="col-sm-8">
                              <input type="date" class="form-control" placeholder="12345"   id="filter_end_followup_date" value={filter_end_followup_date} onChange={updatefilter_end_followup_date}  />
                              <code>{filter_end_followup_date_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="row">
                      <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Next Followup Start Date</label>
                            <div class="col-sm-8">
                              <input type="date" class="form-control" placeholder="12345"   id="filter_start_next_followup_date" value={filter_start_next_followup_date} onChange={updatefilter_start_next_followup_date}  />
                              <code>{filter_start_next_followup_date_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Next Followup End Date</label>
                            <div class="col-sm-8">
                              <input type="date" class="form-control" placeholder="12345"   id="filter_end_next_followup_date" value={filter_end_next_followup_date} onChange={updatefilter_end_next_followup_date}  />
                              <code>{filter_end_next_followup_date_er}</code>
                            </div>
                          </div>
                        </div>
                        </div>
                    
                      <div style={{marginBottom:"1rem"}}>
                  
                         <button class="btn btn-primary" onClick={()=>{ setfilter_val(1); getData(); }}>Apply Filters</button>
                         <button class="btn btn-danger" style={{marginLeft:"1rem"}} onClick={()=>{ setfilter_val(0); getData(); }}>Remove Filters</button>
                       
                      </div>
                            <hr/>                      
                            </div>
                            
                            {/* FILTER SECTION END */}

                    <div class="col-12" style={{marginBottom:"2rem"}}>
                    <div class="template-demo d-flex justify-content-between">
                    <div></div>

                     {/* COLUMNS MANAGEMENT DROPDOWN START */}
                     <div class="dropdown">
                            <button class="btn btn-warning" onClick={()=>{ document.getElementById("filter-top-card").style.display="block"; }}><i class="mdi mdi-filter-outline"></i></button>
                            <button class="btn btn-primary dropdown-toggle" style={{marginLeft:"1rem"}} type="button" id="dropdownMenuIconButton1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="mdi mdi-table-large"></i>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuIconButton1">
                              <h6 class="dropdown-header">Columns</h6>
                              <hr/>
                              
                              {/* Column 1 */}
                              <li><div class="d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Lead Id</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c1_yes" onClick={()=>{setcd_col1_val(1); document.getElementById("cd_c1_yes").style.display="none"; document.getElementById("cd_c1_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c1_no" style={{ display:"none"}} onClick={()=>{ setcd_col1_val(0); document.getElementById("cd_c1_yes").style.display="block"; document.getElementById("cd_c1_no").style.display="none"; }}></i>
                              </div></div></li> 
                               {/* Column 2 */}
                               <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Customer Id</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c2_yes"  onClick={()=>{setcd_col2_val(1); document.getElementById("cd_c2_yes").style.display="none"; document.getElementById("cd_c2_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c2_no" style={{ display:"none"}} onClick={()=>{ setcd_col2_val(0); document.getElementById("cd_c2_yes").style.display="block"; document.getElementById("cd_c2_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 3 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">First Name</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c3_yes"  onClick={()=>{setcd_col3_val(1); document.getElementById("cd_c3_yes").style.display="none"; document.getElementById("cd_c3_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c3_no" style={{ display:"none"}} onClick={()=>{ setcd_col3_val(0); document.getElementById("cd_c3_yes").style.display="block"; document.getElementById("cd_c3_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 4 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Last Name</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c4_yes"  onClick={()=>{setcd_col4_val(1); document.getElementById("cd_c4_yes").style.display="none"; document.getElementById("cd_c4_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c4_no" style={{ display:"none"}} onClick={()=>{ setcd_col4_val(0); document.getElementById("cd_c4_yes").style.display="block"; document.getElementById("cd_c4_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 5 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Email</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c5_yes"  onClick={()=>{setcd_col5_val(1); document.getElementById("cd_c5_yes").style.display="none"; document.getElementById("cd_c5_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c5_no" style={{ display:"none"}} onClick={()=>{ setcd_col5_val(0); document.getElementById("cd_c5_yes").style.display="block"; document.getElementById("cd_c5_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 6 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Contact</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c6_yes"  onClick={()=>{setcd_col6_val(1); document.getElementById("cd_c6_yes").style.display="none"; document.getElementById("cd_c6_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c6_no" style={{ display:"none"}} onClick={()=>{ setcd_col6_val(0); document.getElementById("cd_c6_yes").style.display="block"; document.getElementById("cd_c6_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 7 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Followup Date</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c7_yes" onClick={()=>{setcd_col7_val(1); document.getElementById("cd_c7_yes").style.display="none"; document.getElementById("cd_c7_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c7_no" style={{ display:"none"}} onClick={()=>{ setcd_col7_val(0); document.getElementById("cd_c7_yes").style.display="block"; document.getElementById("cd_c7_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 8 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Consulting For</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c8_yes" onClick={()=>{setcd_col8_val(1); document.getElementById("cd_c8_yes").style.display="none"; document.getElementById("cd_c8_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c8_no" style={{ display:"none"}} onClick={()=>{ setcd_col8_val(0); document.getElementById("cd_c8_yes").style.display="block"; document.getElementById("cd_c8_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 9 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Lead Type</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c9_yes" onClick={()=>{setcd_col9_val(1); document.getElementById("cd_c9_yes").style.display="none"; document.getElementById("cd_c9_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c9_no" style={{ display:"none"}} onClick={()=>{ setcd_col9_val(0); document.getElementById("cd_c9_yes").style.display="block"; document.getElementById("cd_c9_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 10 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Lead Stage</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c10_yes" onClick={()=>{setcd_col10_val(1); document.getElementById("cd_c10_yes").style.display="none"; document.getElementById("cd_c10_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c10_no" style={{ display:"none"}} onClick={()=>{ setcd_col10_val(0); document.getElementById("cd_c10_yes").style.display="block"; document.getElementById("cd_c10_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 11 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Action</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c11_yes" onClick={()=>{setcd_col11_val(1); document.getElementById("cd_c11_yes").style.display="none"; document.getElementById("cd_c11_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c11_no" style={{ display:"none"}} onClick={()=>{ setcd_col11_val(0); document.getElementById("cd_c11_yes").style.display="block"; document.getElementById("cd_c11_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 12 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Followup Mode</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c12_yes" onClick={()=>{setcd_col12_val(1); document.getElementById("cd_c12_yes").style.display="none"; document.getElementById("cd_c12_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c12_no" style={{ display:"none"}} onClick={()=>{ setcd_col12_val(0); document.getElementById("cd_c12_yes").style.display="block"; document.getElementById("cd_c12_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 13 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Next Followup Date</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c13_yes" onClick={()=>{setcd_col13_val(1); document.getElementById("cd_c13_yes").style.display="none"; document.getElementById("cd_c13_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c13_no" style={{ display:"none"}} onClick={()=>{ setcd_col13_val(0); document.getElementById("cd_c13_yes").style.display="block"; document.getElementById("cd_c13_no").style.display="none"; }}></i>
                              </div></div></li> 
                              {/* Column 14 */}
                              <li><div class=" d-flex" style={{flexDirection:"row"}}><div style={{marginLeft:"0.2rem"}} class="col-sm-10">Last Updated</div>
                              <div class="col-sm-2"><i class="mdi mdi-eye text-primary" id="cd_c14_yes" onClick={()=>{setcd_col14_val(1); document.getElementById("cd_c14_yes").style.display="none"; document.getElementById("cd_c14_no").style.display="block"; }}></i>
                              <i class="mdi mdi-eye-off text-danger" id="cd_c14_no" style={{ display:"none"}} onClick={()=>{ setcd_col14_val(0); document.getElementById("cd_c14_yes").style.display="block"; document.getElementById("cd_c14_no").style.display="none"; }}></i>
                              </div></div></li> 
                            {/*}  <div class="dropdown-divider"></div>
                              <button class="btn btn-danger">Close</button>*/}
                            </div> 
                          </div>
                          {/* COLUMNS MANAGEMENT DROPDOWN END */}

                          </div>
                          </div>

                    <div class="table-responsive" id="reports" ref={componentRef}>
                      <table class="table table-hover">
                        <thead>
                          <tr >
                            <th  style={{fontWeight:"bold"}} hidden={cd_col1_val==1} >Lead Id</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col2_val==1} >Customer Id</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col3_val==1} >First Name</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col4_val==1} >Last Name</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col5_val==1} >Email</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col6_val==1} >Contact</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col7_val==1} >Followup Date</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col8_val==1} >Consulting For</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col9_val==1} >Lead Type</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col10_val==1} >Lead Stage</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col11_val==1} >Action</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col12_val==1} >Followup Mode</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col13_val==1} >Next Followup Date</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col14_val==1} >Last Updated</th>
                          </tr>
                        </thead>
                        <tbody>
                        {
                       data.map((curElm,ind)=>{

                         return(
                         <>
                      
                        <tr>
                            <td hidden={cd_col1_val == 1}>{curElm.Lead_id}</td>
                            <td hidden={cd_col2_val==1} >{curElm.Customer_id}</td>
                            <td hidden={cd_col3_val==1} >{curElm.First_name}</td>
                            <td hidden={cd_col4_val==1} >{curElm.Last_name}</td>
                            <td hidden={cd_col5_val==1} >{curElm.Email}</td>
                            <td hidden={cd_col6_val==1} >{curElm.Contact}</td>
                            <td hidden={cd_col7_val==1} >{curElm.Followup_date}
                           {/*} <label hidden={(curElm.Type=="cash")||(curElm.Type=="bank")} class="badge badge-warning">credit</label>
                            <label class="badge badge-success" hidden={(curElm.Type == "bank")||(curElm.Type == "credit")}>{curElm.Type}</label>
                            <label class="badge badge-primary" hidden={(curElm.Type == "cash")||((curElm.Type == "credit"))}>{curElm.Type} ({curElm.Bank_name})</label>
                           */} </td>
                            <td hidden={cd_col8_val==1} >{curElm.Consulting_for}</td>
                            <td hidden={cd_col9_val==1} >{curElm.Lead_type}</td>
                            <td hidden={cd_col10_val==1} >{curElm.Lead_stage}</td>
                            <td hidden={cd_col11_val==1} >{curElm.Action}</td>
                            <td hidden={cd_col12_val==1} >{curElm.Followup_mode}</td>
                            <td hidden={cd_col13_val==1} >{curElm.Next_followup_date}</td>
                          {/*}  <td hidden={cd_col9_val==1} ><button class="btn btn-primary" onClick={()=>{
                              //Setting Session and Redirect to Invoice Page
                              sessionStorage.setItem("Trno00",curElm.Tr_no); window.location.replace("businesstools-user-sales-invoice");
                            }}>View</button> </td>
                            <td hidden={cd_col10_val==1} >{curElm.Updated_by}</td> */}
                            <td hidden={cd_col14_val==1} >{curElm.Date_updated} ({curElm.Time_updated})</td>
                          {/*}  <td hidden={cd_col12_val==1} ><i class="mdi mdi-pencil-box text-warning" style={{fontSize:"1.4rem"}} onClick={()=>{ 
                        //Setting edit Id and Redirect to Edit
                    //  sessionStorage.setItem("Editid00",curElm.Id);sessionStorage.setItem("Trno00",curElm.Tr_no);getsalesdatabyId();document.getElementById('edit-form').style.display = 'block'; 
                    }}
                    ></i></td>
                            <td hidden={cd_col13_val==1} ><i class="mdi mdi-delete-forever text-danger" style={{fontSize:"1.4rem"}} onClick={()=>{ 
                        //Setting edit Id for Delete
                    //</td>    sessionStorage.setItem("DEditId00",curElm.Id);      sessionStorage.setItem("DTrno00",curElm.Tr_no); document.getElementById('delete-card').style.display = 'block'; 
                    }}

                    ></i></td>*/}

                          </tr>
                          </>
                         )
                         }
                       
                             )
                         }
                          
                       
                          
                         
                        </tbody>
                      </table>
                    </div>
                     {/* PAGINATION SECTION START */}
                     <div>
                       <div class="col-12" style={{marginBottom:"2rem",marginTop:"1rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                       
                          <div class="dropdown">
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber-1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-left-drop-circle text-success"></i></button>
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber+1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-right-drop-circle text-success"></i></button>
                          </div>
                          </div>
                          </div>
                    </div>
                    {/* PAGINATION SECTION END */}

                    <button class="btn btn-light" onClick={handlePrint}><i class="mdi mdi-cloud-print text-dark"></i></button>
                    <button class="btn btn-light" onClick={getexcelData}><i class="mdi mdi-file-excel text-dark"></i></button>
                    
                  </div>
                </div>
              </div>
               {/* SALES TRANSACTIONS LIST END */}
            

            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
        {/*}  <footer class="footer">
            <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i class="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);

//}
}
export default Newcrm_leads;